import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

import { ModalPessoalTermoReferenciaPage } from '../../../modais/modal-pessoal-termo-referencia/modal-pessoal-termo-referencia';
import { ModalPessoalEvidenciasPage } from '../../../modais/modal-pessoal-evidencia/modal-pessoal-evidencia';
import { ModalArquivosPage } from '../../../modais/modal-arquivos/modal-arquivos';

@Component({
    selector: 'page-termos-referencia-contrato',
    templateUrl: 'termos-referencia-contrato.html',
    providers: [
        PessoalService
    ]
})
export class PessoalTermosReferenciaContratoPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "105";
    codigoModulo: any;
    analise: any;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.codigoModulo = this.navParams.get('analise').idModuloPca;
        this.analise = this.navParams.get('analise');

        this.carregarDados();
        this.setModuloId(11);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.pessoalService.obterTermosReferenciaContrato().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    salvarFlagIncluir() {

        this.loading = true;

        this.listaDados.dsResumoAnalise = this.capitalize(this.listaDados.dsResumoAnalise);
        this.pessoalService.salvarTermosReferenciaContrato(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";

        this.loading = true;

        if (this.listaDados.dsResumoAnalise == undefined || !this.listaDados.dsResumoAnalise || this.listaDados.dsResumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResumoAnalise == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;
                this.listaDados.dsResumoAnalise = this.capitalize(this.listaDados.dsResumoAnalise);
                this.pessoalService.finalizarTermosReferenciaContrato(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaPessoal();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }

    modalEvidencias(item) {
        this.apresentaModalEvidencias("Evidências", item, ModalPessoalEvidenciasPage);
    }

    apresentaModalEvidencias(titulo: String, objeto: any, modalPage: any) {

        let modal = this.modalCtrl.create(ModalArquivosPage,
            {
                titulo: titulo,
                IdProcesso: objeto.referencia.numeroContrato,
                idModuloPCA: this.codigoModulo,
                tipoAnalise: '108',
                jurisdicionado: this.isJurisdicionado,
                isCGE: this.isCGE,
                origemArquivo: "Contrato: " + objeto.referencia.numeroContrato,
                origemFilter: 'PESSOAL',
                tipoEntidadeExercicio: 0,
                tipodocumento: 0,
                analise: this.analise
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
            }
        });

        modal.present();
    }

    modalAtividades(item) {
        this.apresentaModalAtividades("Atribuições", item.referencia, ModalPessoalTermoReferenciaPage);
    }

    apresentaModalAtividades(titulo: String, objeto: any, modalPage: any) {
        let modal = this.modalCtrl.create(modalPage, { param1: titulo, objeto: objeto, isCGE: true, analise: this.analise });
        modal.onDidDismiss(retornoModal => {

        });
        modal.present();
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.toString().split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.toString().split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    cnpj_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/termos-referencia-contrato/termos-referencia-contrato.ts